const {
  iterableCurry
} = require('../../internal/iterable.js');

function* __append(source, value) {
  yield* source;
  yield value;
}

exports.__append = __append;
const append = /*#__PURE__*/iterableCurry(__append);
exports.append = append;